
import apiClient from "../utils/axiosInterceptor";


export const fetchNegotiationActions = async (): Promise<any> => {
  try {
    const response = await apiClient.get(`fapp-core-api/api/NegotiationActions`);
    if (response.status === 200) {

      return response.data;
    }
  } catch (error) {

    return error || 500;
  }
};

export const negotiationActionRelation = async (): Promise<any> => {
  try {
    const response = await apiClient.get(`fapp-core-api/api/NegotiationActionRelations`);
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    return error || 500;
  }
};

export const addNegoAction = async (data: any) => {

  const payload = {
    Title: data.payload.newAction.name,
    Description: data.payload.newAction.description,
    RelatedPhase: data.payload.newAction.type

  }

  try {
    const response = apiClient.post(`fapp-core-api/api/NegotiationActions`, payload);
    return response;
  } catch (error: any) {
    console.error("Error adding negotiation action", error);
    return error.response?.status || 500;
  }
}

export const deleteNegoAction = async (data: any) => {

  const payload = {
    Id: data.payload.id,
    status: data.payload.status
  }

  try {
    const response = apiClient.put(`fapp-core-api/api/NegotiationActions`, payload);

    return response;
  } catch (error: any) {
    console.error("Error deleting negotiation action", error);
    return error.response?.status || 500;
  }
}
export const getAISuggestionForActionCardsAPI = async (payload: any) => {

  try {
    const response = await apiClient.post(`/fapp-ai-api/api/AISearchHandler`, payload);
    return response;
  } catch (error: any) {
    console.error('Error fetching:', error);
    return error.response?.status || 500;
  }
}




